// pages/Register.js
import { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaCut,
  FaUser,
  FaEnvelope,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaArrowRight,
  FaGoogle,
  FaFacebookF,
  FaCalendarCheck,
} from 'react-icons/fa';
import './Auth.css';

function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(name, email, password);
  };

  return (
    <div className="auth-page">
      <div className="auth-wrapper">
        {/* LEFT PANEL */}
        <div className="auth-visual">
          <div className="visual-top">
            <div className="brand-row">
              <span className="brand-icon-box">
                <FaCut />
              </span>
              <span className="brand-name">Glow & Style</span>
            </div>
            <div className="badge-pill">
              <FaCalendarCheck className="badge-icon" />
              SALON BILLING PLATFORM
            </div>

            <h1 className="visual-heading">
              Start running <br />
              your salon <br />
              <span>the smart way</span>
            </h1>

            <p className="visual-text">
              Create your account and set up billing, staff, and services
              in minutes — no paperwork, no hassle.
            </p>

            <div className="stats-row">
              <div className="stat-item">
                <h3>8K+</h3>
                <span>Salons Onboard</span>
              </div>
              <div className="stat-item">
                <h3>1.2M+</h3>
                <span>Bills Generated</span>
              </div>
              <div className="stat-item">
                <h3>50+</h3>
                <span>Cities</span>
              </div>
            </div>
          </div>

          <div className="testimonial-box">
            <p>
              "Setting up our salon on Glow & Style took less than ten
              minutes. Billing has never been this simple."
            </p>
            <div className="testimonial-user">
              <div className="avatar">AK</div>
              <div>
                <strong>Ankit Kapoor</strong>
                <span>Manager, Urban Cuts</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="auth-form-side">
          <div className="auth-form-box">
            <div className="form-head">
              <h2>Create your account</h2>
              <p>
                Already have an account? <Link to="/">Sign in →</Link>
              </p>
            </div>
{/* 
            <div className="social-row">
              <button type="button" className="social-btn">
                <FaGoogle className="social-icon google" /> Continue with Google
              </button>
              <button type="button" className="social-btn">
                <FaFacebookF className="social-icon facebook" /> Continue with Facebook
              </button>
            </div>

            <div className="divider">
              <span>or sign up with email</span>
            </div> */}

            <form onSubmit={handleSubmit}>
              <label className="field-label">Full Name</label>
              <div className="input-group">
                <FaUser className="input-icon" />
                <input
                  type="text"
                  placeholder="Your full name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <label className="field-label">Email Address</label>
              <div className="input-group">
                <FaEnvelope className="input-icon" />
                <input
                  type="email"
                  placeholder="you@salon.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <label className="field-label">Password</label>
              <div className="input-group">
                <FaLock className="input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Create a password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <span
                  className="toggle-icon"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>

              <button type="submit" className="auth-btn">
                Create Account <FaArrowRight className="btn-icon" />
              </button>
            </form>

            <p className="auth-switch">
              Already have an account? <Link to="/">Sign in</Link>
            </p>

            <p className="fine-print">
              By creating an account you agree to our{' '}
              <Link to="/terms">Terms of Service</Link> and{' '}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;